import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { VirtualTimeScheduler } from 'rxjs';

@Component({
	selector: 'admin-home',
	templateUrl: './admin-home.component.html',
	styleUrls: ['./admin-home.component.css']
})
export class AdminHomeComponent implements OnInit {

	loading : boolean = false; 
	currentView = 'main';
	fakulteti : any = [];
	studProgrami : any = [];
	idStudPrograma : any = null;
	prijave : any = [];
	novaPrijavaFakultet : boolean = true; 
	odabraniFakultetId : any = null;
	prekoPortala = false;
	//old
	idFakulteta : any = null;
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	prijavafakultetobradi : any = null;
	msg : any = null;

	constructor(public globalSrvc: GlobalService, public http : HttpClient) { }

	ngOnInit() {
		setTimeout(() => {
			/*var elems = document.querySelectorAll('.modal');
    		var instances = M.Modal.init(elems, {});*/
		}, 1000);

		this.ucitajFakultete();	
	}

	ucitajFakultete(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + 'prijave/admin/fakulteti', {params: {}})
			.subscribe(data => {
				this.fakulteti = data;
				this.prijave = [];
				this.loading = false;

				setTimeout(() => {
					let elems = document.querySelectorAll('.tooltipped');
            		let instances = M.Tooltip.init(elems, {});    
				}, 1000);
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	fakultetselected(event){
		this.ucitajStudPrograme();
	}

	ucitajStudPrograme(){
		this.loading = true;
		this.studProgrami = [];		
		this.prijave = [];

		this.http.get('prijave/fakulteti/studprogrami', { params: { idFakulteta: this.idFakulteta } })
			.subscribe(data => {
				this.loading = false;
				this.studProgrami = data;
			}
			,error => {
				this.loading = false;
			}
		);
	}

	logout(){
		this.globalSrvc.logout();
		this.globalSrvc.redirectToLogin();
	}

	result : any = null;

	studProgramSelected(event){
		this.ucitajKandidate();
	}

	ucitajKandidate(){
		this.loading = true; 
		this.sortOption = 1;

		this.http.get(this.globalSrvc.rootUrl + 'prijave/admin/admin/ranglista', {params: {idFakulteta : this.idFakulteta, idStudPrograma : this.idStudPrograma}})
		.subscribe(data => {
			if (data){
				this.result = data;
				this.prijave = this.result.kandidati;
				//console.log(this.prijave);
			}
			this.loading = false;
		},
		error => {
			this.loading = false;
		});	
	}
	getBodoviLuca(luca){
		if (!luca)
		 	return '';
		
		if (luca == 1)
		 	return 5;
		if (luca == 2)
			return 3;

		return '';
	}

	getOcjenaExterna(extocjena){
		if (!extocjena)
		 	return '';
		
		return extocjena;
	}

	getBodoviTakmicenja(bodovi){
		if (!bodovi)
			return '';

		if (bodovi == '2')
			return 'I';

		if (bodovi == '1')
			return 'II';
		
		return '';
	}

	getNazivDugmetaSort(){
		return this.sortOption==1?'Sortiraj po vremenu':'Sortiraj po bodovima';
	}

	prikaziStatistiku(){
		this.currentView = "statistika";
	}

	prikaziRokove(){
		this.currentView = "rokovi";
	}

	onCancel(data){
		this.currentView = 'main';
	}

	obradiprijavu(prijava){
		this.prijavafakultetobradi = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal91');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	obradiPrijavuFakultetPotvrda(){
		let url = 'admin/prijava/status/izmjena';

		this.loading = true;

		setTimeout(() => {				
			let obj = {idPrijave : this.prijavafakultetobradi.id, status : '1'};

			this.http.post(url, obj)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitajKandidate();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}
}
